<template>
  <div id="app">
    <el-row id="headerTitle">
      <el-col :span="20">
        <h1>Layout 设计器 - 当前编辑看板名称:{{ layoutData.title }}</h1>
      </el-col>
      <el-col :span="4">
        <div class="buttonWrapper">
          <el-button @click="onSave">保存</el-button>
          <el-button @click="onPreview">预览</el-button>
        </div>
      </el-col>
    </el-row>

    <el-row id="main">
      <el-col id="leftArea" :span="3">
        <el-collapse accordion value="1">
          <el-collapse-item name="1">
            <template slot="title">
              <h3>设备列表</h3>
             
              <i class="header-icon el-icon-info"></i>
              <p>点击添加到看板上</p>
            </template>

            <el-tooltip
                :key="item.id"
                effect="dark"
                :content="item.no"
                placement="left"
                v-for="(item, index) of equipments"
            >
           
              <div class="equipItemTooltip" slot="content">
                <p>{{ item.no }}</p>
                 <p>{{ item.title }}</p>
                <!-- <p>{{ item.raw.andon_no }}</p> -->
              </div>
              <div
                  @click.stop="equipItemClick(index, $event)"
                  class="equipItem "
              >
                {{ item.no }} - {{ item.title }} - {{ item.raw}}
              </div>
            </el-tooltip>
          </el-collapse-item>
          <el-collapse-item title="其他组件" name="2">
            <div>
              <h5 class="equipItem" @click.stop="custormItemClick()">
                自定义组件
              </h5>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-col>
      <el-col :span="17">
        <div class="dashboard_wrapper">
          <div
              class="dashboard"
              :style="getStyle(board.background)"
              @click.stop="onDashboardClick"
          >
            <div
                :key="item.id"
                class="equipItem "
                :class="'equipItem_' + item.id"
                v-for="item of board.equips"
                @click.stop="onDashboardEquipItemClick"
                :style="getStyle(item)"
            >
              <div class="text">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="4">
        <template v-if="currentItem">
          <h5>
            当前选择:{{ currentItem.title || currentItem.no }} - {{ currentItem.no }}-{{ currentItem.id }}
          </h5>
          <el-form ref="formEquip" :model="currentItem" label-width="80px">
            <el-form-item prop="title" label="显示内容">
              <el-input v-model.number="currentItem.title"></el-input>
            </el-form-item>

            <el-form-item prop="style.border" label="边框属性">
              <el-input v-model="currentItem.style.border"></el-input>
            </el-form-item>
            <el-form-item prop="style.width" label="宽度">
              <el-input v-model.number="currentItem.style.width">
                <template slot="append">px</template>
              </el-input>
            </el-form-item>
            <el-form-item prop="style.height" label="高度">
              <el-input v-model.number="currentItem.style.height">
                <template slot="append">px</template>
              </el-input>
            </el-form-item>
            <el-form-item prop="style.color" label="字体颜色">
              <el-input v-model="currentItem.style.color"></el-input>
            </el-form-item>
            <el-form-item prop="style.background" label="字号设置">
              <el-input v-model="currentItem.style['font-size']"></el-input>
            </el-form-item>
            <el-form-item prop="style.background" label="行高设置">
              <el-input v-model="currentItem.style.lineHeight"></el-input>
            </el-form-item>
            <el-form-item prop="style.background" label="背景图">
              <el-input v-model="currentItem.style.background"></el-input>
            </el-form-item>
            <el-form-item prop="style['box-shadow']" label="阴影">
              <el-input v-model="currentItem.style['box-shadow']"></el-input>
            </el-form-item>
            <el-form-item prop="dragga.position" label="当前位置X">
              <el-input disabled v-model.number="currentItem.dragga.position.x">
              </el-input>
            </el-form-item>
            <el-form-item prop="dragga.position" label="当前位置Y">
              <el-input disabled v-model.number="currentItem.dragga.position.y">
              </el-input>
            </el-form-item>
            <el-form-item prop="style['z-index']" label="Z轴">
              <el-input v-model.number="currentItem.style['z-index']"></el-input>
            </el-form-item>
            <el-form-item prop="style.transform" label="旋转角度">
              <el-input v-model.number="currentItem.style.transform">
                <template slot="append">deg</template>
              </el-input>
            </el-form-item>

            <el-button
                @click="remove(currentItem)"
                icon="el-icon-delete"
                type="danger"
            >删除元素
            </el-button
            >
          </el-form>
        </template>
        <template v-else>
          <h5>当前选择:背景</h5>
          <div class="formWrapper">
            <el-form
                ref="formBackground"
                :model="board.background.style"
                label-width="80px"
            >
              <el-form-item prop="width" label="宽度">
                <el-input v-model.number="board.background.style.width">
                  <template slot="append">px</template>
                </el-input>
              </el-form-item>
              <el-form-item prop="height" label="高度">
                <el-input v-model.number="board.background.style.height">
                  <template slot="append">px</template>
                </el-input>
              </el-form-item>
              <el-form-item prop="background" label="背景图">
                <el-input v-model="board.background.style.background">
                </el-input>
              </el-form-item>
            </el-form>
          </div>
        </template>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Draggabilly from 'draggabilly';
import {getEuipment} from '@/service/equipmentService';
import {fetchLayoutData, saveLayoutData} from '@/service/layoutDataService';
import {getStyle} from '@/util/utils';

export default {
  name: 'app',
  data: () => {
    return {
      currentItem: null,
      layoutData: {
        id: '',
        title: '加载中..',
      },
      equipments:  [],
      onBoardIdSet: new Set(),
      equipmentsMap: new Map(),
      board: {
        equips: [],
        background: {
          type: 'background',
          style: {
            width: '1200',
            height: '900',
            background: '',
          },
        },
      },
    };
  },

  components: {
    // HelloWorld,
  },
  async mounted() {
    const {id} = this.$route.params;
    console.log(id)
    if (!id) {
      this.$message('ID 出错,请重新进入!');
    }
    const layoutData = await fetchLayoutData(id);
    this.layoutData = {id: layoutData.data.data.rowid, title: layoutData.data.data.workshop};
    try {
      const raw = JSON.parse(layoutData.data.data.raw || "{}");
      if (raw.background && raw.equips) {
        this.board = raw;
        this.board.equips.forEach(item => {
          this.onBoardIdSet.add(item.rowid);
        });
      }
    } catch (e) {
      this.$message('解析失败!');
      console.warn(e)
    }

    const equipments = await getEuipment();

    this.equipments=equipments.data.data.rows.map(item =>({ 
      id: item.rowid,
      title: item.name,
      no: item.equ_no,
      style: {},
      status: item.statu,
      type: 'equip',
    }))
    if(this.equipments){
      this.equipments = this.equipments.map(item => {
        this.equipmentsMap.set(item.no, item);
        return {
          id: item.id,
          title: item.title,
          no: item.no,
          style: {},
          status: item.status,
          type: 'equip',
        };
      });
    }
  },
  methods: {
    equipItemClick(index, event) {
      console.log('index',index,event)
      console.log(this.equipments[index].id)
      console.log('set',this.onBoardIdSet)
      if (this.onBoardIdSet.has(this.equipments[index].no)) {
        this.$message.error('已经放入了相同设备!');
        return false;
      }
      const equipItem = this.equipments.splice(index, 1);
      this.board.equips.push(equipItem[0]);
      this.onBoardIdSet.add(equipItem[0].no);
    },
    custormItemClick() {
      this.board.equips.push({
        id: new Date().valueOf(),
        title: '自定义组件',
        type: 'custom',
        no: '默认编号',
        style: {},
      });
    },
    onDashboardEquipItemClick(event) {
      console.log('event-onDashboardEquipItemClick', event);
    },
    onDashboardClick(event) {
      this.currentItem = null;
      console.log('event-onDashboardClick', event);
    },
    getStyle(item) {
      return getStyle(item, this.equipmentsMap);
    },
    async onSave() {
      const raw = JSON.stringify(this.board);
      const data = await saveLayoutData(
          this.layoutData.id,
          this.layoutData.title,
          raw
      );
      console.log('111data',data)
      this.$message(data.statusText);
    },
    onPreview() {
      const win = window.open();
      win.location.href = './index.html#/preview/' + this.layoutData.id;
    },
    remove(item) {
      let index = -1;
      this.board.equips.forEach((_item, _index) => {
        if (_item.id === item.id) {
          index = _index;
        }
        return;
      });
      this.board.equips.splice(index, 1);
    },
  },
  watch: {
    'board.equips': function (equips) {
      const self = this;
      setTimeout(() => {
        this.equipDrage = equips.map(equipItem => {
          const dragga = new Draggabilly(
              document.querySelector('.equipItem_' + equipItem.id),
              {
                containment: '.dashboard',
                grid: [20, 20],
              }
          );
          dragga.on('staticClick', function () {
            equipItem.dragga = this;
            self.currentItem = equipItem;
          });
          dragga.on('dragStart', function () {
            equipItem.dragga = this;
            self.currentItem = equipItem;
          });

          dragga.on('dragEnd', function () {
            equipItem.style.position = 'absolute';
            equipItem.style.left = this.position.x;
            equipItem.style.top = this.position.y;
            equipItem.style.transform = 0;
            console.log('this', this, equipItem);

          });
          return dragga;
        });
      }, 500);
    },
  },
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-size: 16px;
  color: #2c3e50;
  background-color: rgb(224, 237, 241);
}

#app {
  height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 0;
}

#headerTitle {
  height: 4rem;
  width: 100%;
  position: fixed;
  z-index: 10;
}

#headerTitle .buttonWrapper {
  padding-top: 1rem;
}

#main {
  height: 100%;
  padding-top: 4rem;
}

#main .el-col {
  height: 100%;
  border-top: 1px solid #ccc;
  border-right: 1px solid #ccc;
}

#main .el-col:last-child {
  border-right: none;
}

.equipItem {
  border: 1px solid #ccc;
  width: 10rem;
  height: 2rem;
  line-height: 2rem;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

#leftArea {
  position: relative;
  max-height: 800px;
  overflow: scroll;
}

#leftArea .equipItem {
  margin: 0.2rem auto;
}

.dashboard_wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.dashboard {
  position: relative;
  background: white;
  margin: 0 auto;
}

.dashboard .equipItem {
  cursor: move;
  position: absolute;
  left: 0;
  top: 0;
}

.dashboard .equipItem .text {
  position: absolute;
  width: 100%;
  text-align: center;
}
</style>
